(() => {
  const timers = new WeakMap();

  async function queryAlgolia(appId, apiKey, indexName, query, league) {
    const filters = [league && `league:"${league}"`, 'published:true'].filter(Boolean).join(' AND ');
    try {
      const res = await fetch(`https://${appId}-dsn.algolia.net/1/indexes/${encodeURIComponent(indexName)}/query`, {
        method: 'POST',
        headers: {
          'X-Algolia-Application-Id': appId,
          'X-Algolia-API-Key': apiKey,
        },
        body: JSON.stringify({ query, filters, hitsPerPage: 100 }),
      });
      const data = await res.json();
      return data.hits ?? [];
    } catch {
      return [];
    }
  }

  function renderHits(list, hits) {
    list.innerHTML = hits
      .map(
        (hit) => `
        <li>
          <a
            href="${hit.url ? hit.url : `/collections/${hit.team_tag}`}"
            class="flex items-center gap-3.5 py-3.5 pr-3.5 text-sm border-b border-silver text-dove-grey hover:text-primary-dark transition-all ease-in"
          >
            ${hit.logo ? `<img src="${hit.logo}" alt="${hit.logo_alt || ''}" class="w-4 h-4 object-contain shrink-0 mr-2">` : ''}
            <span class="capitalize">${(() => {
              const base = hit.name.replace(/-/g, ' ').toLowerCase();
              const override = hit.override;
              if (!override) return base;
              return base.replace(new RegExp(override, 'i'), `<span style="text-transform:none">${override}</span>`);
            })()}</span>
          </a>
        </li>
      `
      )
      .join('');
  }

  document.addEventListener('input', (e) => {
    const input = e.target;
    if (input.name !== 'team-search') return;

    clearTimeout(timers.get(input));

    timers.set(
      input,
      setTimeout(async () => {
        const { appId, apiKey, teamsIndex, league } = {
          appId: input.dataset.appId,
          apiKey: input.dataset.apiKey,
          teamsIndex: input.dataset.teamsIndex,
          league: input.dataset.league,
        };

        if (!appId || !teamsIndex) return;

        const list = document.querySelector(`[data-teams-list="${league}"]`);
        if (!list) return;

        const hits = await queryAlgolia(appId, apiKey, teamsIndex, input.value.trim(), league);
        renderHits(list, hits);
      }, 300)
    );
  });
})();
